import { Injectable } from '@angular/core';
import {
  PortalServiceDetailsCustomDetailsResponse,
  PortalServiceDetailsLanguageEnum,
  PortalServiceDetailsLookupDto,
} from '../../models/portal/GetAllServicesDetailResponse';
import { ServiceMetaData } from '../../models/shared/ServiceMetaData';

@Injectable({
  providedIn: 'root',
})
export class PortalServiceDetailsMapperService {
  public resolveLanguageId(lang: string): number {
    return lang == 'ar'
      ? PortalServiceDetailsLanguageEnum.Arabic
      : PortalServiceDetailsLanguageEnum.English;
  }

  public mapMetadata(
    responseData: PortalServiceDetailsCustomDetailsResponse
  ): ServiceMetaData {
    const metadata: ServiceMetaData = {
      name: responseData?.data.title,
      formattedTermsAndConditions:
        responseData?.data.attr.conditionsAndRequirements_string,
      portalLink: responseData?.data.link,
      termsAndConditions:
        responseData?.data.attr.conditionsAndRequirements_string,
      faq: responseData?.data.attr.faq_string,
      digitalNumber: responseData?.data.attr.digitalservice,
      youTubeVideoURL: responseData?.data.attr.webYoutubeLink,
    };

    return metadata;
  }

  private mapConditionsAndRequirements(
    termsAndConditions: PortalServiceDetailsLookupDto[]
  ): string {
    if (termsAndConditions && termsAndConditions[0]) {
      return termsAndConditions[0].text;
    }

    return null;
  }

  private mapFaqs(faqs: PortalServiceDetailsLookupDto[]): string {
    if (faqs && faqs.length) {
      return faqs.map((faq) => `${faq.title} \n ${faq.text}`).join('\n');
    }

    return null;
  }
}
